import { Pipe, PipeTransform } from '@angular/core';
import { ApiTravelMemberHelperService } from './travel-member-helper.service';
import { ucFirst } from '../helpers/function/uc-first';

@Pipe({
  name: 'apiTravelMember',
})
export class ApiTravelMemberHelperPipe implements PipeTransform {
  constructor(
    private _apiTravelMemberHelperSrv: ApiTravelMemberHelperService
  ) {}

  transform(travelMember: any, ...args: any[]): any {
    const [fct] = args;
    args.shift();
    return (this._apiTravelMemberHelperSrv as any)['get' + ucFirst(fct)](
      travelMember,
      ...args
    );
  }
}

@Pipe({
  name: 'apiTravelMemberU',
  pure: false,
})
export class ApiTravelMemberHelperUnPurePipe
  extends ApiTravelMemberHelperPipe
  implements PipeTransform {}
